import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { Tupas } from '../../../store/actions/authenticationActions';
import { User,UserEmailVerified} from '../../../store/actions/userActions';

@Injectable({
  providedIn: 'root'
})
export class NextstepsService {

  constructor(private http: HttpService, private store: Store<any>) { }


  tupas(payload) {
    return this.http.query('post', 'tupas/login', {}, '', payload , 'openId');
  }
  dispatchTupasAction(payload)
  {
    this.store.dispatch(new Tupas(payload));
  }
  dispatchUserAction()
  {
    this.store.dispatch(new User());
  }
  dispatchUserEmailVerifiedAction()
  {
    this.store.dispatch(new UserEmailVerified());
  }
}
